const SELECTORS = {
  trigger: '.js-scroll-to',
};

class ScrollTo {
  constructor() {
    this.triggers = document.querySelectorAll(SELECTORS.trigger);
    this.init();
  }

  init() {
    this.triggers.forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        const target = document.querySelector(trigger.dataset.target);
        target.scrollIntoView({
          block: 'center',
          behavior: 'smooth',
        });
      });
    });
  }
}

export default () => {
  return new ScrollTo();
};
